import React, { Component } from "react";
import { connect } from "react-redux";
import { userActions } from "../../_actions";
import { AdminMessage, Routes } from "../../_components";
import { userConstants } from "../../_constants";
import "../../assets/css/requestEduStatus.css";
import { ModalSnjob } from "../../_components/ModalSnjob";
import { CardSelect } from "../../_components/pdp-card-select/cardSelect";
import { BtnRound } from "../../_components/BtnRound";
import { Banner, Item, ItemEmpty, List } from "../../_components/ListSnjob";
import { pdpStatus } from "../../_helpers/pdp-status";
import { formatDate } from "../../_helpers/formatDate";

class RequestEduStatusSuperior_ extends Component {
  constructor(props) {
    super(props);
    this.state = {
      titles: [],
      requested_courses: [],
      detailModal: false,
      activeDetail: 0,
    };
    this.globalStorage = this.props.globalStorage;
  }

  componentDidMount() {
    this.getUserWards();
    this.getTitles();
    this.getRequestedCourses();
    document.querySelector(".wave").classList.add("hidden");
  }

  componentWillUnmount = () => {
    document.querySelector(".wave").classList.remove("hidden");
  };

  getUserWards = () => {
    // for authorization user
    this.props
      .dispatch(
        userActions.API("get", `v1/user/hospital/user_wards`, null, true)
      )
      .then((res) => {
        const superiorIds = res.data.map(({ user_id }) => +user_id);
        const myId = this.globalStorage.me.id;
        if (!superiorIds.includes(myId)) {
          userActions.failure("برای شما در این بخش دسترسی تعریف نشده است");
          this.props.history.push("/pdpSites");
        }
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  getTitles = () => {
    this.props
      .dispatch(
        userActions.API("get", `v1/user/hospital/course/titles`, null, true)
      )
      .then((res) => {
        this.setState({ titles: res.data });
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  getRequestedCourses = (job_group = null, post_name = null) => {
    this.props
      .dispatch(
        userActions.API(
          "get",
          `${
            userConstants.SERVER_URL
          }v1/user/hospital/superior/requested_courses?type=history${
            job_group ? `&job_group=${job_group}` : ""
          }${post_name ? `&post_name=${post_name}` : ""}`
        )
      )
      .then((res) => {
        this.setState({ requested_courses: res.data });
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  render() {
    const { dispatch } = this;
    const { titles, requested_courses, detailModal, activeDetail } = this.state;
    if (requested_courses.length === 0) return null;
    const userComment = requested_courses[activeDetail]
      ? requested_courses[activeDetail].requested_courses[0].user_comment
      : null;
    const superior_description = requested_courses[activeDetail]
      ? requested_courses[activeDetail].requested_courses[0]
          .superior_description
      : null;

    const supervisor_description = requested_courses[activeDetail]
      ? requested_courses[activeDetail].requested_courses[0]
          .supervisor_description
      : null;

    const detail = requested_courses[activeDetail];
    const { superior_submitted_at, supervisor_submitted_at, submitted_at } =
      detail?.requested_courses[0];

    // const { firstname, lastname } = this.globalStorage.me;
    // const {
    // 	superior_submitted_at,
    // 	supervisor_submitted_at,
    // 	submitted_at,
    // 	superior,
    // 	user_comment,
    // 	superior_description,
    // 	supervisor_description,
    // } = courses[0];
    // const dates = [submitted_at, superior_submitted_at, supervisor_submitted_at];
    // const names = [
    // 	`درخـواست کننده نیاز آموزشی (${firstname} ${lastname})`,
    // 	`مافــوق (${superior.firstname} ${superior.lastname})`,
    // 	'سـازمــان',
    // ];
    // const labels = [`${firstname} ${lastname}`, `${superior.firstname} ${superior.lastname}`, 'سـازمــان'];

    return (
      <div className="requestEduStatus bg-light bg-drr pt-3 pb-5 px-3">
        <Routes page="pdp/requestEduStatus" />
        <div className="container-fluid">
          <div className="card bg-white shadow text-center border-0">
            <AdminMessage />
          </div>
        </div>
        <br />
        <NotifCard text1="وضعیت نیازسنجی های درخواستی در بیمارستان شما" />
        <br />
        <div className="container-fluid px-5 pb-5">
          <div className="row">
            <div className="col-xl-12 col-lg-9 col-md-12 m-auto">
              <List
                className="transparent-scroll container-fluid px-0"
                style={{ height: "60vh" }}
              >
                <ul
                  className="list position-relative w-100 m-0 p-2"
                  style={{
                    boxShadow: "none",
                  }}
                >
                  <Banner
                    className="py-3"
                    grid="1fr 2fr 2fr 2fr 2fr 2fr 2fr 3fr 2fr"
                    key={0}
                  >
                    <div
                      className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                      style={{ fontSize: "12.6px" }}
                    >
                      ردیف
                    </div>
                    <div
                      className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                      style={{ fontSize: "12.6px" }}
                    >
                      نام
                    </div>
                    <div
                      className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                      style={{ fontSize: "12.6px" }}
                    >
                      نام خانوادگی
                    </div>
                    <div
                      className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                      style={{ fontSize: "12.6px" }}
                    >
                      تاریخ درخواست
                    </div>
                    <div
                      className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                      style={{ fontSize: "12.6px" }}
                    >
                      تاریخ اعمال نظر
                    </div>
                    <div
                      className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                      style={{ fontSize: "12.6px" }}
                    >
                      سمت
                    </div>
                    <div
                      className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                      style={{ fontSize: "12.6px" }}
                    >
                      گروه شغلی
                    </div>
                    <div
                      className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                      style={{ fontSize: "12.6px" }}
                    >
                      وضعیت
                    </div>
                    <div
                      className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                      style={{ fontSize: "12.6px" }}
                    >
                      مشاهده وضعیت
                    </div>
                  </Banner>
                  {requested_courses.length && titles.length ? (
                    requested_courses.map((request, i) => {
                      const { user, requested_courses } = request;
                      const { firstname, lastname, post } = user;
                      const { job_group, name } = post;
                      const { submitted_at, created_at, status } =
                        requested_courses[0];

                      const statusText =
                        status === "superior_pending"
                          ? "در انتظار تایید توسط شما"
                          : status === "supervisor_pending"
                          ? "در انتظار بررسی توسط سازمان"
                          : status === "rejected_by_superior"
                          ? "در انتظار تایید توسط سازمان"
                          : status === "active"
                          ? "بررسی شده توسط سازمان"
                          : status === "rejected_by_supervisor" ||
                            status === "active"
                          ? "بررسی شده توسط سازمان"
                          : "xxx";
                      const jobGroupText = job_group
                        ? job_group.length > 20
                          ? job_group.slice(0, 20) + "..."
                          : job_group
                        : "گروه شغلی ندارید";

                      return (
                        <Item
                          className="py-1"
                          grid="1fr 2fr 2fr 2fr 2fr 2fr 2fr 3fr 2fr"
                          key={i + 1}
                        >
                          <div
                            className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                            style={{ gap: "10px", fontSize: "15px" }}
                          >
                            <p className="itemComp__text text-center text-primary m-0">
                              {i + 1}
                            </p>
                          </div>
                          <div
                            className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                            style={{ gap: "10px", fontSize: "15px" }}
                          >
                            <p className="itemComp__text text-center text-primary m-0">
                              {firstname}
                            </p>
                          </div>
                          <div
                            className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                            style={{ gap: "10px", fontSize: "15px" }}
                          >
                            <p className="itemComp__text text-center text-primary m-0">
                              {lastname}
                            </p>
                          </div>
                          <div
                            className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                            style={{ gap: "10px", fontSize: "15px" }}
                          >
                            <p className="itemComp__text text-center text-primary m-0 iran-sans-imp">
                              {formatDate(created_at)}
                            </p>
                          </div>
                          <div
                            className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                            style={{ gap: "10px", fontSize: "15px" }}
                          >
                            <p className="itemComp__text text-center text-primary m-0 iran-sans-imp">
                              {formatDate(submitted_at)}
                            </p>
                          </div>
                          <div
                            className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                            style={{ gap: "10px", fontSize: "15px" }}
                          >
                            <p className="itemComp__text text-center text-primary m-0">
                              {name}
                            </p>
                          </div>
                          <div
                            className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                            style={{ gap: "10px", fontSize: "15px" }}
                          >
                            <p className="itemComp__text text-center text-primary m-0">
                              {jobGroupText}
                            </p>
                          </div>
                          <div
                            className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                            style={{ gap: "10px", fontSize: "15px" }}
                          >
                            <p className="itemComp__text text-center text-primary m-0">
                              {statusText}
                            </p>
                          </div>
                          <div
                            className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                            style={{ gap: "10px", fontSize: "15px" }}
                          >
                            <BtnRound
                              className="detail-icon"
                              onClick={() =>
                                this.setState({
                                  activeDetail: i,
                                  detailModal: true,
                                })
                              }
                            />
                          </div>
                        </Item>
                      );
                    })
                  ) : (
                    <ItemEmpty />
                  )}
                </ul>
              </List>
              <ModalSnjob
                title={`${requested_courses[activeDetail].user.firstname} ${
                  requested_courses[activeDetail].user.lastname
                }${
                  requested_courses[activeDetail].user.post.job_group
                    ? ` - ${requested_courses[activeDetail].user.post.job_group}`
                    : ""
                }`}
                className="requestEduStatus"
                isOpen={detailModal}
                onClose={() => this.setState({ detailModal: false })}
              >
                <div
                  className="row mb-4 d-flex justify-content-center align-items-center"
                  style={{ gap: "2rem" }}
                >
                  {userComment && (
                    <CardSelect
                      hideHeader={true}
                      hideTitle={true}
                      style={{ height: "20vh", overflow: "scroll" }}
                      text={userComment}
                      customTitle={
                        <div
                          className="d-flex justify-content-between align-items-center px-3 py-2"
                          style={{ width: "280px" }}
                        >
                          <p className="m-0 text-primary">کاربر</p>
                          <p className="m-0 text-primary iran-sans-imp">
                            {formatDate(submitted_at)}
                          </p>
                        </div>
                      }
                    />
                  )}
                  {superior_description && (
                    <CardSelect
                      hideHeader={true}
                      hideTitle={true}
                      style={{ height: "20vh", overflow: "scroll" }}
                      text={superior_description}
                      customTitle={
                        <div
                          className="d-flex justify-content-between align-items-center px-3 py-2"
                          style={{ width: "280px" }}
                        >
                          <p className="m-0 text-primary">مافوق</p>
                          <p className="m-0 text-primary iran-sans-imp">
                            {formatDate(superior_submitted_at)}
                          </p>
                        </div>
                      }
                    />
                  )}
                  {supervisor_description && (
                    <CardSelect
                      hideHeader={true}
                      hideTitle={true}
                      style={{ height: "20vh", overflow: "scroll" }}
                      text={supervisor_description}
                      customTitle={
                        <div
                          className="d-flex justify-content-between align-items-center px-3 py-2"
                          style={{ width: "280px" }}
                        >
                          <p className="m-0 text-primary">سازمان</p>
                          <p className="m-0 text-primary iran-sans-imp">
                            {formatDate(supervisor_submitted_at)}
                          </p>
                        </div>
                      }
                    />
                  )}
                </div>
                {/* <Timeline dates={dates} names={names} labels={labels} formatDate={formatDate} /> */}
                {/* <Timeline dates={dates} names={names} formatDate={formatDate} detail={detail} /> */}
                <List
                  className="transparent-scroll"
                  container="container-fluid"
                  padding="px-0"
                  style={{ height: "45vh" }}
                >
                  <ul
                    className="list position-relative w-100 m-0 p-2"
                    style={{
                      boxShadow: "none",
                    }}
                  >
                    <Banner
                      className="py-3"
                      grid="1fr 4fr 1fr 1fr 1fr 5fr"
                      key={0}
                    >
                      <div
                        className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                        style={{ fontSize: "12.6px" }}
                      >
                        ردیف
                      </div>
                      <div
                        className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                        style={{ fontSize: "12.6px" }}
                      >
                        عنوان نیازسنجی
                      </div>
                      <div
                        className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                        style={{ fontSize: "12.6px" }}
                      >
                        نظر کاربر
                      </div>
                      <div
                        className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                        style={{ fontSize: "12.6px" }}
                      >
                        نظر مافوق
                      </div>
                      <div
                        className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                        style={{ fontSize: "12.6px" }}
                      >
                        نظر سازمان
                      </div>
                      <div
                        className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                        style={{ fontSize: "12.6px" }}
                      >
                        وضعیت
                      </div>
                    </Banner>
                    {requested_courses[activeDetail].requested_courses.length &&
                    titles.length
                      ? requested_courses[activeDetail].requested_courses.map(
                          (course, i) => {
                            const titleObj = titles.find(
                              (title) => title.id === course.course_id
                            );
                            const title = titleObj ? titleObj.title : "xxx";
                            const {
                              userIcon,
                              superiorIcon,
                              supervisorIcon,
                              statusText,
                            } = pdpStatus(course, titles);

                            return (
                              <Item
                                className="py-1"
                                grid="1fr 4fr 1fr 1fr 1fr 5fr"
                                key={i + 1}
                              >
                                <div
                                  className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                                  style={{ gap: "10px", fontSize: "15px" }}
                                >
                                  <p className="itemComp__text text-center text-primary m-0">
                                    {i + 1}
                                  </p>
                                </div>
                                <div
                                  className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                                  style={{ gap: "10px", fontSize: "15px" }}
                                >
                                  <p className="itemComp__text text-center text-primary m-0">
                                    {title}
                                  </p>
                                </div>
                                <div
                                  className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                                  style={{ gap: "10px", fontSize: "15px" }}
                                >
                                  <BtnRound className={`${userIcon}-icon`} />
                                </div>
                                <div
                                  className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                                  style={{ gap: "10px", fontSize: "15px" }}
                                >
                                  <BtnRound
                                    className={`${superiorIcon}-icon`}
                                  />
                                </div>
                                <div
                                  className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                                  style={{ gap: "10px", fontSize: "15px" }}
                                >
                                  <BtnRound
                                    className={`${supervisorIcon}-icon`}
                                  />
                                </div>
                                <div
                                  className="d-flex justify-content-center align-items-center h-100 w-100 text-primary"
                                  style={{ gap: "10px", fontSize: "15px" }}
                                >
                                  <p className="itemComp__text text-center text-primary m-0">
                                    {statusText}
                                  </p>
                                </div>
                              </Item>
                            );
                          }
                        )
                      : null}
                  </ul>
                </List>

                  <button
                    className="btn d-flex justify-content-center text-center btn_edStatus rounded-pill mx-auto"
                    onClick={() => this.setState({ detailModal: false })}
                  >
                    <p className="m-0 py-2">بازگشت</p>
                  </button>
              </ModalSnjob>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// class Timeline extends Component {
// 	constructor(props) {
// 		super(props);
// 		this.state = {
// 			value: this.props.dates.filter((date) => date !== null).length - 1,
// 			previous: 0,
// 		};
// 	}

// 	render() {
// 		const { dates, names, formatDate, detail } = this.props;
// 		const { value } = this.state;
// 		const { user } = detail;
// 		const { firstname, lastname } = user;

// 		return (
// 			<div className='row'>
// 				<div className='col-xl-12 col-lg-8 indexSec timeline mx-auto mb-3'>
// 					<div className='border-0 h-100 '>
// 						<div className='card border-0 shadow-smm' style={{ borderRadius: '20px' }}>
// 							<div className='card-body' style={{ height: '235px' }}>
// 								<div
// 									style={{
// 										width: '100%',
// 										height: '100px',
// 										margin: '0 auto 70px auto',
// 										// marginBottom: "70px",
// 									}}
// 								>
// 									<div className='text-center title'>
// 										<span>{`نـوار اعلام وضعیت نیازسنجی هـای درخـواست شـده توسـط ${firstname} ${lastname}`}</span>
// 									</div>
// 									{/* <div
//                     style={{
//                       height: "100%",
//                       position: "relative",
//                     }}
//                   > */}
// 									<HorizontalTimeline
// 										index={value}
// 										indexClick={(i) => {
// 											if (dates[i] !== null) this.setState({ value: i, previous: value });
// 										}}
// 										values={dates}
// 										getLabel={(_, i) => names[i]}
// 										isOpenBeginning={false}
// 										isOpenEnding={false}
// 										minEventPadding={350}
// 										maxEventPadding={350}
// 										linePadding={100}
// 										styles={{
// 											background: '#f8f8f8',
// 											foreground: '#104C81',
// 											outline: '#999',
// 											// position: "absolute",
// 										}}
// 									/>
// 									{/* </div> */}
// 								</div>
// 								{dates[value] !== null ? (
// 									<>
// 										<div className='text-center'>{`توسط ${names[value]} در تاریخ ${formatDate(
// 											dates[value],
// 										)} تایید شده است`}</div>
// 									</>
// 								) : (
// 									''
// 								)}
// 							</div>
// 						</div>
// 					</div>
// 				</div>
// 			</div>
// 		);
// 	}
// }

class Timeline extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.dates.filter((date) => date !== null).length - 1,
      previous: 0,
    };
  }

  render() {
    const { dates, names, labels, formatDate } = this.props;
    const { value } = this.state;

    return (
      <div className="row timelineParent">
        <div className="col-xl-12 col-lg-12 col-md-11 col-sm-10 indexSec timeline mx-auto mb-3">
          <div className="border-0 h-100 ">
            <div
              className="card border-0 shadow-smm"
              style={{ borderRadius: "20px" }}
            >
              <div className="card-body" style={{ height: "270px" }}>
                <div
                  style={{
                    width: "100%",
                    height: "100px",
                    margin: "0 auto 70px auto",
                  }}
                >
                  <div className="text-center title">
                    <span>
                      نـوار اعلام وضعیت نیازسنجی هـای درخـواست شـده توسـط شمـا
                    </span>
                  </div>
                  <div className="row">
                    <div className="col-12 py-5 d-flex flex-row-reverse justify-content-center align-items-center gap-sm">
                      <div className="position-relative">
                        <BtnRound
                          className={`${
                            value >= 0 ? "bg-primary" : "bg-gray"
                          } basic-logo`}
                          style={{ borderRadius: "50%" }}
                          onClick={() => this.setState({ value: 0 })}
                        />
                        <p
                          className={`position-absolute m-0 btn-text digi-font ${
                            value >= 0 ? "text-primary" : ""
                          }`}
                        >
                          {names[0]}
                        </p>
                      </div>
                      <div
                        className={`line ${value >= 1 ? "line-active" : ""}`}
                      ></div>
                      <div className="position-relative">
                        <BtnRound
                          className={`${
                            value >= 1 ? "bg-primary" : "bg-gray"
                          } payesh-logo`}
                          style={{ borderRadius: "50%" }}
                          onClick={() => this.setState({ value: 1 })}
                        />
                        <p
                          className={`position-absolute m-0 btn-text digi-font ${
                            value >= 1 ? "text-primary" : ""
                          }`}
                        >
                          {names[1]}
                        </p>
                      </div>
                      <div
                        className={`line ${value >= 2 ? "line-active" : ""}`}
                      ></div>
                      <div className="position-relative">
                        <BtnRound
                          className={`${
                            value >= 2 ? "bg-primary" : "bg-gray"
                          } question-logo`}
                          style={{ borderRadius: "50%" }}
                          onClick={() => this.setState({ value: 2 })}
                        />
                        <p
                          className={`position-absolute m-0 btn-text digi-font ${
                            value >= 2 ? "text-primary" : ""
                          }`}
                        >
                          {names[2]}
                        </p>
                      </div>
                    </div>
                  </div>
                  {dates[value] !== null ? (
                    value === 0 ? (
                      <p className="mb-0 mt-4 text-center">
                        {`درخواست ${labels[value]} در تاریخ `}
                        <span className="iran-sans-imp">
                          {formatDate(dates[value])}
                        </span>
                        {`ثبت شد .`}
                      </p>
                    ) : value === 1 ? (
                      <p className="mb-0 mt-4 text-center">
                        {`درخواست شما توسط ${labels[value]} در تاریخ `}
                        <span className="iran-sans-imp">
                          {formatDate(dates[value])}
                        </span>
                        {` بررسی شد.`}
                      </p>
                    ) : (
                      <p className="mb-0 mt-4 text-center">
                        {`درخواست شما توسط ${labels[value]} در تاریخ `}
                        <span className="iran-sans-imp">
                          {formatDate(dates[value])}
                        </span>
                        {` بررسی شد.`}
                      </p>
                    )
                  ) : (
                    <p className="mb-0 mt-4 text-center">
                      این مرحله هنوز تکمیل نشده است
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class NotifCard extends Component {
  render() {
    const { text1, text2, color1 = "#777777", color2 = "#6c00ff" } = this.props;

    return (
      <div className="notif py-3 px-5">
        <p style={{ color: color1, margin: 0 }}>{text1}</p>
        {text2 && (
          <p style={{ color: color2, margin: "10px 0 0 0" }}>{text2}</p>
        )}
      </div>
    );
  }
}

const RequestEduStatusSuperior = connect((state) => ({
  globalStorage: state.globalStorage,
}))(RequestEduStatusSuperior_);
export { RequestEduStatusSuperior };
